import styled from 'styled-components';

import type { Color } from '@genially/design-system';
import MedalIcon from '@genially/icons/lib/medal/MedalIcon';

interface PositionProps {
  $position?: 'first' | 'second' | 'third';
}

const getMedalColor = (color: Color, $position: PositionProps['$position']) => {
  switch ($position) {
    case 'first':
      return color.border.complementary(8);
    case 'second':
      return color.border.secondary.default();
    case 'third':
    default:
      return color.border.complementary(10);
  }
};

export const StyledMedalIcon = styled(MedalIcon)<PositionProps>(
  ({ theme: { color }, $position }) => ({
    color: getMedalColor(color, $position),
  }),
);
